const containerVarname = 'adGlobals';
const globals = containerVarname in window ? window[containerVarname] : {};
window[containerVarname] = globals;

/**
 * Store a value in a shared global registry used across multiple bundles.
 * This function guarantees that the same key always returns the same
 * reference, even when the module is duplicated in different bundles.
 *
 * If the key already exists, its value will not be overwritten. This
 * prevents inconsistent state caused by re-initialization in parallel
 * bundles.
 *
 * @function setGlobal
 * @param {string} key - A stable unique identifier for the global value.
 *   The same key must be used from all bundles that want to share the
 *   same reference.
 * @param {*} value - The value to store if the key is not yet present.
 * @returns {*} The stored value associated with the key. If the key was
 *   already present, the existing reference is returned unchanged.
 */
function setGlobal(key, value) {
    if (!(key in globals)) {
        globals[key] = value;
    }
    return globals[key];
}

/**
 * Retrieve a value from the shared global registry. This allows any
 * bundle to access references that were previously registered with
 * setGlobal().
 *
 * @function getGlobal
 * @param {string} key - The name of the stored global entry.
 * @returns {*} The associated value, or undefined if the key does not
 *   exist in the global registry.
 */
function getGlobal(key) {
    return globals[key];
}

module.exports = {
    getGlobal,
    setGlobal
};
